import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Footer() {
  const [modalOpen, setModalOpen] = useState<'terms' | 'privacy' | null>(null);
  const closeModal = () => setModalOpen(null);
  return <>
      <footer className="bg-wine-dark text-cream/60 py-12 px-6" data-id="element-30">
        <div className="container mx-auto max-w-5xl text-center" data-id="element-31">
          <h3 className="font-serif text-2xl text-cream mb-6" data-id="element-32">
            7 Noches Para Volver a Tocarnos
          </h3>
          <p className="max-w-md mx-auto mb-8 text-sm leading-relaxed" data-id="element-33">
            Una guía diseñada para recuperar la intimidad sin presión,
            respetando los tiempos y emociones de ambos.
          </p>

          <div className="flex justify-center gap-8 text-sm mb-8" data-id="element-34">
            <button onClick={() => setModalOpen('terms')} className="hover:text-amber transition-colors underline underline-offset-4 decoration-transparent hover:decoration-amber" data-id="element-35">
              Términos y Condiciones
            </button>
            <button onClick={() => setModalOpen('privacy')} className="hover:text-amber transition-colors underline underline-offset-4 decoration-transparent hover:decoration-amber" data-id="element-36">
              Política de Privacidad
            </button>
          </div>

          <p className="text-xs opacity-40" data-id="element-37">
            © {new Date().getFullYear()} Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-38">
        {modalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-39">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeModal} className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-40" />

            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto z-10" data-id="element-41">
              <button onClick={closeModal} className="absolute top-4 right-4 p-2 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors text-charcoal" data-id="element-42">
                <X className="w-5 h-5" data-id="element-43" />
              </button>

              <div className="p-8 md:p-10" data-id="element-44">
                {modalOpen === 'terms' ? <TermsContent data-id="element-45" /> : <PrivacyContent data-id="element-46" />}
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}
function TermsContent() {
  return <div className="prose prose-wine max-w-none" data-id="element-47">
      <h2 className="font-serif text-3xl font-bold text-wine-dark mb-6" data-id="element-48">
        Términos y Condiciones
      </h2>

      <h3 data-id="element-49">1. Uso del Producto</h3>
      <p data-id="element-50">
        Al comprar "7 Noches Para Volver a Tocarnos", adquieres una licencia
        personal e intransferible para uso privado. Queda prohibida su
        distribución, venta o reproducción total o parcial sin autorización
        expresa.
      </p>

      <h3 data-id="element-51">2. Propiedad Intelectual</h3>
      <p data-id="element-52">
        Todo el contenido, textos, imágenes y diseño de la guía están protegidos
        por derechos de autor. La compra no transfiere la propiedad intelectual,
        solo el derecho de uso personal.
      </p>

      <h3 data-id="element-53">3. Política de Reembolso</h3>
      <p data-id="element-54">
        Al tratarse de un producto digital de descarga inmediata, todas las
        ventas son finales. No ofrecemos reembolsos una vez que el producto ha
        sido enviado o descargado, salvo que exista un defecto técnico
        comprobable que impida su acceso.
      </p>

      <h3 data-id="element-55">4. Limitación de Responsabilidad</h3>
      <p data-id="element-56">
        Esta guía es un recurso educativo y de entretenimiento. No sustituye la
        terapia profesional ni el consejo médico. Los resultados pueden variar
        según cada pareja y su aplicación de las sugerencias.
      </p>

      <h3 data-id="element-57">5. Modificaciones</h3>
      <p data-id="element-58">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las actualizaciones entrarán en vigor inmediatamente después de
        su publicación en este sitio.
      </p>
    </div>;
}
function PrivacyContent() {
  return <div className="prose prose-wine max-w-none" data-id="element-59">
      <h2 className="font-serif text-3xl font-bold text-wine-dark mb-6" data-id="element-60">
        Política de Privacidad
      </h2>

      <h3 data-id="element-61">1. Datos que Recopilamos</h3>
      <p data-id="element-62">
        Solo recopilamos la información necesaria para procesar tu compra y
        entregar el producto: nombre, correo electrónico y datos de pago
        (procesados de forma segura por nuestros proveedores de pago).
      </p>

      <h3 data-id="element-63">2. Uso de la Información</h3>
      <p data-id="element-64">
        Utilizamos tus datos exclusivamente para:
        <ul data-id="element-65">
          <li data-id="element-66">Entregar el producto digital a tu correo.</li>
          <li data-id="element-67">Brindar soporte técnico si lo necesitas.</li>
          <li data-id="element-68">
            Enviarte actualizaciones relevantes sobre el producto (puedes darte
            de baja en cualquier momento).
          </li>
        </ul>
      </p>

      <h3 data-id="element-69">3. Protección de Datos</h3>
      <p data-id="element-70">
        Tus datos están protegidos con estándares de seguridad de la industria.
        No vendemos, alquilamos ni compartimos tu información personal con
        terceros con fines comerciales.
      </p>

      <h3 data-id="element-71">4. Cookies</h3>
      <p data-id="element-72">
        Utilizamos cookies esenciales para el funcionamiento del carrito de
        compra y análisis anónimo de tráfico para mejorar la experiencia del
        sitio.
      </p>

      <h3 data-id="element-73">5. Contacto</h3>
      <p data-id="element-74">
        Si tienes dudas sobre cómo manejamos tus datos, puedes contactarnos
        respondiendo al correo de confirmación de tu compra.
      </p>
    </div>;
}